
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.33639',
  depVersions: {
  "documents-public-ui": "static-1.33639",
  "client-types": "static-1.438",
  "documents-lib": "static-1.33644",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1791",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4702",
  "highcharts": "static-8.97",
  "hs-promise-utils": "static-1.5264",
  "hs-test-utils": "static-1.7656",
  "hub-http": "static-1.5872",
  "hubspot-dlb": "static-2.1773",
  "HubStyleTokens": "static-2.11092",
  "I18n": "static-7.1535",
  "jasmine-immutable": "static-1.2684",
  "jasmine-runner": "static-1.6127",
  "lodash": "static-1.3",
  "quartz": "static-1.6540",
  "react": "static-7.174",
  "react-dlb": "static-1.68",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.65",
  "react-rhumb": "static-1.16301",
  "reporting-data": "static-1.65951",
  "reporting-testing-lib": "static-1.7885",
  "reporting-visualizations": "static-1.58028",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4418",
  "webpack-env": "static-1.54",
  "atom": "static-1.4746",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2134",
  "classnames": "static-2.10",
  "crm_schema": "static-3.90850",
  "cssUtils": "static-1.691",
  "customer-data-filters-ui": "static-1.38422",
  "customer-data-objects": "static-1.7284",
  "customer-data-property-utils": "static-1.7739",
  "data-fetching-client": "static-1.9348",
  "enviro": "static-4.371",
  "FireAlarmUi": "static-1.4209",
  "flux-actions": "static-1.294",
  "FormsCommonComponents": "static-1.84894",
  "FormUrlGenerator": "static-2.4405",
  "foundations-components": "static-1.7243",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3825",
  "HubStyle": "static-2.11400",
  "icons": "static-2.608",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.6813",
  "metrics-js": "static-1.9296",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.334",
  "property-description-translator": "static-1.3533",
  "property-translator": "static-1.5087",
  "quartz-config": "static-1.318",
  "quartz-core": "static-1.5759",
  "quick-fetch": "static-1.3611",
  "raven": "static-3.5564",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5061",
  "react-virtualized": "static-2.92",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7832",
  "reference-resolvers-lite": "static-1.7765",
  "report-customization-components": "static-1.12159",
  "reporting-enablement": "static-1.21639",
  "reporting-reports": "static-1.65630",
  "reporting-snowflake": "static-1.54570",
  "reporting-ui-components": "static-2.63224",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4276",
  "sales-content-partitioning": "static-1.8608",
  "SalesContentIndexUI": "static-3.8706",
  "sanitize": "static-1.4149",
  "sanitize-text": "static-1.7815",
  "self-service-api": "static-1.9898",
  "SharedI18nStrings": "static-1.179",
  "SharedLegalStrings": "static-1.1451",
  "signup-constants": "static-1.18127",
  "signup-ui-lego-core": "static-1.20137",
  "signup-ui-url-generator": "static-2.7711",
  "styled-components": "static-2.83",
  "StyleGuideUI": "static-3.481",
  "superstore": "static-1.4441",
  "transmute": "static-2.77",
  "ui-addon-form-validation": "static-1.10670",
  "ui-addon-i18n": "static-1.10798",
  "ui-addon-react-router-dom": "static-1.9215",
  "ui-addon-upgrades": "static-9.17378",
  "ui-asset-management-lib": "static-1.10520",
  "ui-images": "static-2.1051",
  "UIComponents": "static-3.8039",
  "usage-tracker": "static-1.7009",
  "usage-tracker-container": "static-1.6999",
  "usage-tracker-core": "static-1.6859",
  "usage-tracker-public": "static-1.6820",
  "viral-links-lib": "static-1.6686",
  "hs-promise-rejection-tracking": "static-1.5234",
  "raven-hubspot": "static-1.5871",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3108",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2817",
  "quartz-webpack": "static-1.2764",
  "ai-components-ui-library": "static-1.8013",
  "amplitude-session-replay-browser": "static-1.53",
  "foundations-assets": "static-1.4504",
  "foundations-theming": "static-1.4075",
  "react-transition-group": "static-1.7",
  "usage-tracker-session-replay": "static-1.4695",
  "foundations-theming-base": "static-1.3060",
  "HeadJS": "static-2.685",
  "framer-motion": "static-1.63",
  "hs-test-utils-bend-plugin": "static-1.2767",
  "msw": "static-1.39",
  "testing-library": "static-1.145",
  "i18n-data": "static-1.214",
  "moment-timezone": "static-5.76",
  "jasmine": "static-4.4007",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7597",
  "graphql": "static-1.75",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3341",
  "persist-promise": "static-1.3357",
  "reporting-client-types": "static-1.2350",
  "hs-story-utils": "static-1.9104",
  "react-flip-move": "static-1.63",
  "hub-http-shared-msw-handlers": "static-1.9147",
  "hubspotter-http": "static-1.4360",
  "sassPrefix": "static-1.149",
  "conversations-skeleton-state": "static-1.6925",
  "crm-message-bus": "static-1.41995",
  "customer-data-filters-ui-msw-helpers": "static-1.20856",
  "customer-data-objects-ui-components": "static-1.12674",
  "customer-data-reference-ui-components": "static-1.12799",
  "customer-data-ui-utilities": "static-1.9496",
  "framework-builder-read-service-client": "static-1.3729",
  "framework-data-schema-quick-fetch": "static-1.6442",
  "framework-data-schema-resolvers": "static-1.6537",
  "inbound-db-properties-service-client": "static-1.3560",
  "multi-account-reference-resolvers": "static-1.637",
  "onboarding-tours": "static-1.16088",
  "reporting-datasets-permissions-lib": "static-1.12626",
  "ui-addon-teams": "static-1.21045",
  "apollo-stack-hubspot": "static-3.79",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67201",
  "customer-data-properties": "static-1.50397",
  "forms-ai-lib": "static-1.3788",
  "forms-utils-lib": "static-1.11922",
  "foundations-components-test-utils": "static-1.4726",
  "react-dnd-compat": "static-1.4298",
  "react-tinymce": "static-1.54269",
  "tinymce-config": "static-2.53395",
  "ui-gdpr-components": "static-1.10020",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3512",
  "floating-ui": "static-1.49",
  "react-aria": "static-1.59",
  "tanstack-table": "static-1.48",
  "trellis-assets": "static-1.929",
  "ui-fonts": "static-1.354",
  "dispatcher": "static-1.129",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.765",
  "mobile-manifest-mixins": "static-1.458",
  "quartz-auth": "static-1.215",
  "quartz-head": "static-1.205",
  "quartz-i18n": "static-1.215",
  "quartz-test": "static-1.215",
  "batch-promise": "static-1.1200",
  "external-options-client-types": "static-1.3865",
  "react-colorpicker": "static-2.9887",
  "reporting-insights-lib": "static-1.788",
  "copilot-toolkit": "static-1.10205",
  "data-quality-ui-library": "static-1.12031",
  "html-to-image": "static-1.47",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40359",
  "reporting-plugins": "static-1.9815",
  "ui-addon-draggable-compat": "static-2.3928",
  "ui-addon-opt": "static-4.8063",
  "ui-shepherd-react": "static-3.9813",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24355",
  "hubspot-apollo-client": "static-1.4554",
  "sales-templates-service-types-lib": "static-1.3876",
  "ui-business-units-lib": "static-1.8682",
  "merchandise-lib": "static-1.253",
  "emoji-regex": "static-1.7",
  "feature-store-service-types": "static-1.4202",
  "purchase-motions-components": "static-1.5292",
  "salesImages": "static-1.518",
  "ts-schema": "static-1.3786",
  "upgrade-management-service-types": "static-1.4193",
  "timezone-utils": "static-2.4918",
  "bender-build-tools": "static-1.2779",
  "chatspot-core": "static-1.19826",
  "bend-plugin-foundations-theming": "static-1.2558",
  "stylex": "static-1.25",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3504",
  "crm-pipelines-api-client-types": "static-1.3847",
  "multi-currency-client-types": "static-1.3404",
  "getting-started-shared-tasks": "static-1.17496",
  "growth-data-modal": "static-1.5003",
  "growth-onboarding-confetti": "static-1.2725",
  "growth-onboarding-next-action-utils": "static-1.1163",
  "navigation-components": "static-1.16895",
  "onboarding-tours-client": "static-1.4302",
  "onboarding-tours-utils": "static-1.154",
  "ui-shepherd-tracker": "static-1.7194",
  "ui-universal-auth": "static-1.8513",
  "user-context": "static-1.4761",
  "cms-field-types": "static-1.4476",
  "content-icons-ui": "static-1.2107",
  "integrations-lib": "static-1.15002",
  "calling-global-api": "static-1.63210",
  "calling-internal-common": "static-1.30962",
  "calling-lifecycle-internal": "static-1.64592",
  "calling-lifecycle-messages": "static-1.56886",
  "commerce-products-lib": "static-1.8456",
  "crm-links": "static-1.5918",
  "file-manager-components": "static-1.22509",
  "google-libphonenumber": "static-1.31",
  "hs-entities": "static-1.323",
  "inbounddb-objects-service-types": "static-1.3932",
  "meetings-icalendar-utils-lib": "static-1.307",
  "object-builder-ui-client": "static-1.47547",
  "pipeline-validation-client-types": "static-1.3668",
  "property-value-citations": "static-1.1011",
  "pulse": "static-1.156",
  "smart-property-lib": "static-1.5415",
  "tiered-pricing": "static-1.625",
  "ui-addon-iframeable": "static-1.8679",
  "final-form": "static-1.63",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19246",
  "tinymce-themes": "static-1.55365",
  "data-token-picker": "static-1.15837",
  "hub-http-contrib": "static-1.2722",
  "interframe": "static-3.4462",
  "tinymce-data": "static-1.39480",
  "tinymce-plugins": "static-1.56509",
  "ui-addon-sales-email": "static-1.4888",
  "hubspotter-http-shared-msw-handlers": "static-1.9145",
  "magpie-lib": "static-1.5247",
  "magpie-types": "static-1.4707",
  "simple-logging-lib": "static-1.2724",
  "content-assistance-lib": "static-1.7262",
  "dashboard-lib": "static-1.80115",
  "ExportDialog": "static-6.10061",
  "hubspot-prosemirror": "static-1.17256",
  "hubspot-prosemirror-plugins": "static-1.17248",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8361",
  "campaign-roi-lib": "static-1.7894",
  "feedback-loader": "static-1.28633",
  "commerce-analytics-service-client": "static-1.3355",
  "onboarding-scopes": "static-1.6115",
  "apollo-link-hub-http": "static-2.4322",
  "hubspot-apollo-cache": "static-1.13",
  "growth-monetization-service-types": "static-1.4209",
  "nav-client-types": "static-1.2006",
  "purchase-motions-api": "static-1.5295",
  "trials-service-types": "static-1.3610",
  "chatspot-client-types": "static-1.10310",
  "idb-keyval": "static-1.37",
  "reactive-lib": "static-1.400",
  "getting-started-shared-tasks-store": "static-1.16614",
  "integrations-error-boundary-lib": "static-1.12417",
  "integrations-tracking-lib": "static-1.5257",
  "native-integrations-shared-strings": "static-1.7461",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10048",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.30968",
  "shared-worker-versioning": "static-1.10691",
  "calling-usage-tracker": "static-1.6212",
  "calling-orchestration-shared-library": "static-1.34398",
  "customer-data-tracking": "static-1.6535",
  "products-iframe-lib": "static-1.7008",
  "products-ui-components-shared-msw-handlers": "static-1.9529",
  "location-customization-utils-lib": "static-1.8139",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.3830",
  "video-components-external": "static-1.10169",
  "video-data-lib": "static-1.33827",
  "directed-graph": "static-1.608",
  "event-emitter": "static-1.599",
  "breeze-intelligence-kit": "static-1.5133",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9230",
  "fsm": "static-1.3405",
  "policy-lib": "static-1.6476",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9293",
  "navigation-messaging": "static-1.6222",
  "FileManagerLib": "static-1.38149",
  "NamespacedHubStyle": "static-2.8784",
  "FileManagerCore": "static-1.38008",
  "codemirror": "static-5.88",
  "layout-dnd-components": "static-1.11813",
  "layout-dnd-utils": "static-1.10788",
  "react-codemirror": "static-1.10277",
  "ui-addon-emoji-picker": "static-1.9564",
  "ui-brand-identity-lib": "static-1.13339",
  "ui-addon-video-player": "static-1.8395",
  "ui-coaching-tips": "static-1.27582",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8266",
  "payment-link-components": "static-1.22582",
  "EmailSignatureEditor": "static-1.23694",
  "eligibility-engine-service-types": "static-1.2891",
  "universal-page-editor-lib": "static-1.2671",
  "calling-orchestration-schema": "static-1.34623",
  "sales-views-client-types": "static-1.3967",
  "crm-record-cards-service-types": "static-1.3341",
  "content-media-composition-data-lib": "static-1.10904",
  "content-media-compositions": "static-2.14911",
  "media-bridge-lib": "static-1.18361",
  "trellis-story-utils": "static-1.4197",
  "storybook-react": "static-1.26",
  "audio-components": "static-1.5430",
  "FileManagerImages": "static-1.35660",
  "video-components": "static-1.12172",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4199",
  "video-embed": "static-1.34661",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67276",
  "layout-data-lib": "static-1.9113",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6260",
  "commerce-tours-lib": "static-1.5521",
  "growth-onboarding-reliability": "static-1.4762",
  "sales-checkout-service-client": "static-1.3367",
  "draft-convert": "static-2.31",
  "draft-extend": "static-2.46",
  "draft-js": "static-5.37",
  "draft-plugins": "static-2.21085",
  "sales-email-signature-service-client": "static-1.3513",
  "hls.js": "static-1.32",
  "social-insights-client-types": "static-1.21050",
  "outpost": "static-1.3888",
  "advanced-menus-core": "static-1.14612",
  "advanced-menus-lib": "static-1.11611",
  "ui-memberships-settings-lib": "static-1.33072",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14611",
  "simple-menus-lib": "static-1.16128"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.33639",
  "client-types": "/client-types/static-1.438",
  "documents-lib": "/documents-lib/static-1.33644",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1791",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4702",
  "highcharts": "/highcharts/static-8.97",
  "hs-promise-utils": "/hs-promise-utils/static-1.5264",
  "hs-test-utils": "/hs-test-utils/static-1.7656",
  "hub-http": "/hub-http/static-1.5872",
  "hubspot-dlb": "/hubspot-dlb/static-2.1773",
  "HubStyleTokens": "/HubStyleTokens/static-2.11092",
  "I18n": "/I18n/static-7.1535",
  "jasmine-immutable": "/jasmine-immutable/static-1.2684",
  "jasmine-runner": "/jasmine-runner/static-1.6127",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6540",
  "react": "/react/static-7.174",
  "react-dlb": "/react-dlb/static-1.68",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.65",
  "react-rhumb": "/react-rhumb/static-1.16301",
  "reporting-data": "/reporting-data/static-1.65951",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.7885",
  "reporting-visualizations": "/reporting-visualizations/static-1.58028",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4418",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4746",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2134",
  "classnames": "/classnames/static-2.10",
  "crm_schema": "/crm_schema/static-3.90850",
  "cssUtils": "/cssUtils/static-1.691",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38422",
  "customer-data-objects": "/customer-data-objects/static-1.7284",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7739",
  "data-fetching-client": "/data-fetching-client/static-1.9348",
  "enviro": "/enviro/static-4.371",
  "FireAlarmUi": "/FireAlarmUi/static-1.4209",
  "flux-actions": "/flux-actions/static-1.294",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.84894",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4405",
  "foundations-components": "/foundations-components/static-1.7243",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3825",
  "HubStyle": "/HubStyle/static-2.11400",
  "icons": "/icons/static-2.608",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.6813",
  "metrics-js": "/metrics-js/static-1.9296",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.334",
  "property-description-translator": "/property-description-translator/static-1.3533",
  "property-translator": "/property-translator/static-1.5087",
  "quartz-config": "/quartz-config/static-1.318",
  "quartz-core": "/quartz-core/static-1.5759",
  "quick-fetch": "/quick-fetch/static-1.3611",
  "raven": "/raven/static-3.5564",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5061",
  "react-virtualized": "/react-virtualized/static-2.92",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7832",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7765",
  "report-customization-components": "/report-customization-components/static-1.12159",
  "reporting-enablement": "/reporting-enablement/static-1.21639",
  "reporting-reports": "/reporting-reports/static-1.65630",
  "reporting-snowflake": "/reporting-snowflake/static-1.54570",
  "reporting-ui-components": "/reporting-ui-components/static-2.63224",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4276",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8608",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8706",
  "sanitize": "/sanitize/static-1.4149",
  "sanitize-text": "/sanitize-text/static-1.7815",
  "self-service-api": "/self-service-api/static-1.9898",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.179",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1451",
  "signup-constants": "/signup-constants/static-1.18127",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20137",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7711",
  "styled-components": "/styled-components/static-2.83",
  "StyleGuideUI": "/StyleGuideUI/static-3.481",
  "superstore": "/superstore/static-1.4441",
  "transmute": "/transmute/static-2.77",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10670",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10798",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9215",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17378",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10520",
  "ui-images": "/ui-images/static-2.1051",
  "UIComponents": "/UIComponents/static-3.8039",
  "usage-tracker": "/usage-tracker/static-1.7009",
  "usage-tracker-container": "/usage-tracker-container/static-1.6999",
  "usage-tracker-core": "/usage-tracker-core/static-1.6859",
  "usage-tracker-public": "/usage-tracker-public/static-1.6820",
  "viral-links-lib": "/viral-links-lib/static-1.6686",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5234",
  "raven-hubspot": "/raven-hubspot/static-1.5871",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3108",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2817",
  "quartz-webpack": "/quartz-webpack/static-1.2764",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8013",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.53",
  "foundations-assets": "/foundations-assets/static-1.4504",
  "foundations-theming": "/foundations-theming/static-1.4075",
  "react-transition-group": "/react-transition-group/static-1.7",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4695",
  "foundations-theming-base": "/foundations-theming-base/static-1.3060",
  "HeadJS": "/HeadJS/static-2.685",
  "framer-motion": "/framer-motion/static-1.63",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2767",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.145",
  "i18n-data": "/i18n-data/static-1.214",
  "moment-timezone": "/moment-timezone/static-5.76",
  "jasmine": "/jasmine/static-4.4007",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7597",
  "graphql": "/graphql/static-1.75",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3341",
  "persist-promise": "/persist-promise/static-1.3357",
  "reporting-client-types": "/reporting-client-types/static-1.2350",
  "hs-story-utils": "/hs-story-utils/static-1.9104",
  "react-flip-move": "/react-flip-move/static-1.63",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9147",
  "hubspotter-http": "/hubspotter-http/static-1.4360",
  "sassPrefix": "/sassPrefix/static-1.149",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6925",
  "crm-message-bus": "/crm-message-bus/static-1.41995",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.20856",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12674",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12799",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9496",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3729",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6442",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6537",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3560",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.637",
  "onboarding-tours": "/onboarding-tours/static-1.16088",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12626",
  "ui-addon-teams": "/ui-addon-teams/static-1.21045",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67201",
  "customer-data-properties": "/customer-data-properties/static-1.50397",
  "forms-ai-lib": "/forms-ai-lib/static-1.3788",
  "forms-utils-lib": "/forms-utils-lib/static-1.11922",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4726",
  "react-dnd-compat": "/react-dnd-compat/static-1.4298",
  "react-tinymce": "/react-tinymce/static-1.54269",
  "tinymce-config": "/tinymce-config/static-2.53395",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10020",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3512",
  "floating-ui": "/floating-ui/static-1.49",
  "react-aria": "/react-aria/static-1.59",
  "tanstack-table": "/tanstack-table/static-1.48",
  "trellis-assets": "/trellis-assets/static-1.929",
  "ui-fonts": "/ui-fonts/static-1.354",
  "dispatcher": "/dispatcher/static-1.129",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.765",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.458",
  "quartz-auth": "/quartz-auth/static-1.215",
  "quartz-head": "/quartz-head/static-1.205",
  "quartz-i18n": "/quartz-i18n/static-1.215",
  "quartz-test": "/quartz-test/static-1.215",
  "batch-promise": "/batch-promise/static-1.1200",
  "external-options-client-types": "/external-options-client-types/static-1.3865",
  "react-colorpicker": "/react-colorpicker/static-2.9887",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.788",
  "copilot-toolkit": "/copilot-toolkit/static-1.10205",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12031",
  "html-to-image": "/html-to-image/static-1.47",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40359",
  "reporting-plugins": "/reporting-plugins/static-1.9815",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.3928",
  "ui-addon-opt": "/ui-addon-opt/static-4.8063",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9813",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24355",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4554",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3876",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8682",
  "merchandise-lib": "/merchandise-lib/static-1.253",
  "emoji-regex": "/emoji-regex/static-1.7",
  "feature-store-service-types": "/feature-store-service-types/static-1.4202",
  "purchase-motions-components": "/purchase-motions-components/static-1.5292",
  "salesImages": "/salesImages/static-1.518",
  "ts-schema": "/ts-schema/static-1.3786",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4193",
  "timezone-utils": "/timezone-utils/static-2.4918",
  "bender-build-tools": "/bender-build-tools/static-1.2779",
  "chatspot-core": "/chatspot-core/static-1.19826",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2558",
  "stylex": "/stylex/static-1.25",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3504",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3847",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3404",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17496",
  "growth-data-modal": "/growth-data-modal/static-1.5003",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2725",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1163",
  "navigation-components": "/navigation-components/static-1.16895",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4302",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.154",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7194",
  "ui-universal-auth": "/ui-universal-auth/static-1.8513",
  "user-context": "/user-context/static-1.4761",
  "cms-field-types": "/cms-field-types/static-1.4476",
  "content-icons-ui": "/content-icons-ui/static-1.2107",
  "integrations-lib": "/integrations-lib/static-1.15002",
  "calling-global-api": "/calling-global-api/static-1.63210",
  "calling-internal-common": "/calling-internal-common/static-1.30962",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64592",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.56886",
  "commerce-products-lib": "/commerce-products-lib/static-1.8456",
  "crm-links": "/crm-links/static-1.5918",
  "file-manager-components": "/file-manager-components/static-1.22509",
  "google-libphonenumber": "/google-libphonenumber/static-1.31",
  "hs-entities": "/hs-entities/static-1.323",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3932",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.307",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47547",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3668",
  "property-value-citations": "/property-value-citations/static-1.1011",
  "pulse": "/pulse/static-1.156",
  "smart-property-lib": "/smart-property-lib/static-1.5415",
  "tiered-pricing": "/tiered-pricing/static-1.625",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8679",
  "final-form": "/final-form/static-1.63",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19246",
  "tinymce-themes": "/tinymce-themes/static-1.55365",
  "data-token-picker": "/data-token-picker/static-1.15837",
  "hub-http-contrib": "/hub-http-contrib/static-1.2722",
  "interframe": "/interframe/static-3.4462",
  "tinymce-data": "/tinymce-data/static-1.39480",
  "tinymce-plugins": "/tinymce-plugins/static-1.56509",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4888",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9145",
  "magpie-lib": "/magpie-lib/static-1.5247",
  "magpie-types": "/magpie-types/static-1.4707",
  "simple-logging-lib": "/simple-logging-lib/static-1.2724",
  "content-assistance-lib": "/content-assistance-lib/static-1.7262",
  "dashboard-lib": "/dashboard-lib/static-1.80115",
  "ExportDialog": "/ExportDialog/static-6.10061",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17256",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17248",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8361",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.7894",
  "feedback-loader": "/feedback-loader/static-1.28633",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3355",
  "onboarding-scopes": "/onboarding-scopes/static-1.6115",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4322",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.13",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4209",
  "nav-client-types": "/nav-client-types/static-1.2006",
  "purchase-motions-api": "/purchase-motions-api/static-1.5295",
  "trials-service-types": "/trials-service-types/static-1.3610",
  "chatspot-client-types": "/chatspot-client-types/static-1.10310",
  "idb-keyval": "/idb-keyval/static-1.37",
  "reactive-lib": "/reactive-lib/static-1.400",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16614",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12417",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5257",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7461",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10048",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.30968",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10691",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6212",
  "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.34398",
  "customer-data-tracking": "/customer-data-tracking/static-1.6535",
  "products-iframe-lib": "/products-iframe-lib/static-1.7008",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9529",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8139",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.3830",
  "video-components-external": "/video-components-external/static-1.10169",
  "video-data-lib": "/video-data-lib/static-1.33827",
  "directed-graph": "/directed-graph/static-1.608",
  "event-emitter": "/event-emitter/static-1.599",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5133",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9230",
  "fsm": "/fsm/static-1.3405",
  "policy-lib": "/policy-lib/static-1.6476",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9293",
  "navigation-messaging": "/navigation-messaging/static-1.6222",
  "FileManagerLib": "/FileManagerLib/static-1.38149",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8784",
  "FileManagerCore": "/FileManagerCore/static-1.38008",
  "codemirror": "/codemirror/static-5.88",
  "layout-dnd-components": "/layout-dnd-components/static-1.11813",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10788",
  "react-codemirror": "/react-codemirror/static-1.10277",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9564",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13339",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8395",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27582",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8266",
  "payment-link-components": "/payment-link-components/static-1.22582",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23694",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2891",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2671",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34623",
  "sales-views-client-types": "/sales-views-client-types/static-1.3967",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3341",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.10904",
  "content-media-compositions": "/content-media-compositions/static-2.14911",
  "media-bridge-lib": "/media-bridge-lib/static-1.18361",
  "trellis-story-utils": "/trellis-story-utils/static-1.4197",
  "storybook-react": "/storybook-react/static-1.26",
  "audio-components": "/audio-components/static-1.5430",
  "FileManagerImages": "/FileManagerImages/static-1.35660",
  "video-components": "/video-components/static-1.12172",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4199",
  "video-embed": "/video-embed/static-1.34661",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67276",
  "layout-data-lib": "/layout-data-lib/static-1.9113",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6260",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5521",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4762",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3367",
  "draft-convert": "/draft-convert/static-2.31",
  "draft-extend": "/draft-extend/static-2.46",
  "draft-js": "/draft-js/static-5.37",
  "draft-plugins": "/draft-plugins/static-2.21085",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3513",
  "hls.js": "/hls.js/static-1.32",
  "social-insights-client-types": "/social-insights-client-types/static-1.21050",
  "outpost": "/outpost/static-1.3888",
  "advanced-menus-core": "/advanced-menus-core/static-1.14612",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11611",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33072",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14611",
  "simple-menus-lib": "/simple-menus-lib/static-1.16128"
}
};
